
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 10.8h-5c-.276 0-.5.227-.5.507v12.185c0 .28.224.508.5.508h5c.276 0 .5-.228.5-.508V11.307a.503.503 0 00-.5-.507z","fill":"#8EE1A0"}}),_c('path',{attrs:{"d":"M15 0H9c-.33 0-.6.224-.6.5v23c0 .276.27.5.6.5h6c.332 0 .6-.224.6-.5V.5c0-.276-.268-.5-.6-.5zM23.5 3.6h-5c-.276 0-.5.24-.5.536v19.327c0 .296.224.537.5.537h5c.276 0 .5-.24.5-.537V4.136c0-.296-.224-.536-.5-.536z","fill":"#35B852"}})])
          )
        }
      }
    